import React from 'react'

 function Load() {
  return (
    <div>
        <h1>
          Loading...
        </h1>
    </div>
  )
}
export default Load;